module.exports = __webpack_public_path__ + "static/media/2_pl.b12702fa.png";